import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Nightsbridge**
 *
 * @exports bs_319
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let refreshPrice;
    const onePaxHotelsList = [
        1037096, // Gonana Guesthouse
        1036653, // Morgan Bay
        1036082, // Tzaneen
        1029553, // Motswiri Private Safari Lodge
        1036800, // Bay View Resort Namibia
        1037277, // Rhino Ridge Safari Lodge
        1044841, // Belvidere Manor
        1044838, // Portland Manor
        1044842, // Rooiberg Lodge
    ];
    const isHotelWithOnePax = onePaxHotelsList.includes(thn.data.propertyId);
    /**
       * @memberOf module:bs_319
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const container = document.querySelector('.room-listing-controller');
        if (container && !thn.nightsbridgePageCheck) {
            thn.nightsbridgePageCheck = thn.debounce(thn.pageCheck, 500);
            thn.observeDom(container, thn.nightsbridgePageCheck, {
                childList: true,
                subtree: true,
                attributes: false,
            });
            thn.shutdown(function () {
                thn.nightsbridgePageCheck.cancel();
                thn.stopObserveDom(container, thn.nightsbridgePageCheck);
                delete thn.nightsbridgePageCheck;
            });
        }
        thn.shutdown(thn.delegate('click', '.check-avl-btn', () => {
            window.setTimeout(function () {
                if (thn.data.pageName === 'Rooms and Rates') {
                    thn.widgets.price.refresh();
                }
            }, 2000);
        }));
        // The message that appears in the case of a sold out does not disappear from searching for new dates when rooms are available.
        // It is a function used as a solution to it.
        // By request, we only applied this to Isibindi Africa Lodges.
        const isIsibindiAfricaLodges = thn.data.accountUserId === 1042570;
        if (isIsibindiAfricaLodges) {
            const onPriceSet = ({ changed, firstTime }) => {
                if (changed && !firstTime) {
                    thn.pageCheck({ force: true });
                }
            };
            const eventName = 'thn:price.set';
            thn.bus.on(eventName, onPriceSet);
            thn.shutdown(() => {
                thn.bus.detach(eventName, onPriceSet);
            });
        }
    };
    /**
       * @memberOf module:bs_319
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('main');
        if (container && !refreshPrice) {
            refreshPrice = thn.debounce(() => thn.widgets.price.refresh(), 450);
            thn.observeDom(container, refreshPrice, {
                childList: true,
                subtree: true,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(container, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
       * @memberOf module:bs_319
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Some hotels do not want to mark the price as special even they have a special flag
        const IS_ISIBINI_AFRICA_LODGES = thn.data.accountUserId === 1042570;
        const isSpecialException = IS_ISIBINI_AFRICA_LODGES;
        // Dates
        const checkinDay = document.querySelectorAll('.checkin-block-day-number')[0]?.textContent || '';
        const checkinMonth = document.querySelectorAll('.checkin-block-day-name')[1]?.textContent || '';
        const checkoutDay = document.querySelectorAll('.checkin-block-day-number')[1]?.textContent || '';
        const checkoutMonth = document.querySelectorAll('.checkin-block-day-name')[3]?.textContent || '';
        if (checkinDay && checkinMonth && checkoutDay && checkoutMonth) {
            widgetData.dateBegin = translateDate(`${checkinDay} ${checkinMonth}`, thn.data.language || 'en');
            widgetData.dateEnd = translateDate(`${checkoutDay} ${checkoutMonth}`, thn.data.language || 'en');
        }
        // Prices
        const rooms = [...document.querySelectorAll('#roomlisting-controller>.ng-star-inserted')].map((el) => {
            const price = thn.parseNumber(((el.querySelector('.show-rate-column span:nth-child(2)'))?.textContent || 0));
            let adults = ((el.querySelector('.room-listing-description>ul>li>span:nth-child(2)'))?.textContent || 0);
            if (isHotelWithOnePax) {
                adults = 1;
            }
            else {
                adults = adults ? adults.match(/\d+/g) : 2;
            }
            const isSpecial = !isSpecialException && [...el.querySelectorAll('img')].some((img) => img.src?.includes('special_flag'));
            return {
                price: price,
                adults: thn.parseNumber(adults),
                special: isSpecial,
            };
        }).filter((room) => room.price && room.adults);
        rooms.sort((a, b) => a.price - b.price);
        // Currency
        let currency = (document.querySelector('.room-listing-price div.show-rate-column>span:nth-child(2)')?.textContent || '').match(/^[^d.]/);
        if (currency) {
            if (currency[0] === 'R') {
                currency = 'ZAR';
            }
            else if (currency[0] === 'N') {
                currency = 'NAD';
            }
            else {
                currency = thn.parseCurrency(currency[0]);
            }
        }
        else {
            currency = 'ZAR';
        }
        // No rooms
        const noRooms = !!document.querySelector('.enq-message-box')?.textContent?.match(/no availability/);
        // For property 1034668 we will multiply the price of the room by the total guests.
        if (!thn.empty(rooms) && currency) {
            widgetData.adults = thn.parseNumber(rooms[0].adults);
            widgetData.children = 0;
            widgetData.guests = widgetData.adults + widgetData.children;
            widgetData.price = (thn.data.propertyId === 1034668) ? (rooms[0].price * widgetData.guests) : rooms[0].price;
            widgetData.currency = currency;
            widgetData.priceSpecial = rooms[0].special;
            widgetData.set = true;
        }
        else if (noRooms) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_319
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // Booking Data
        const bookingId = thn.parseNumber(((document.querySelector('.bookingid>span:nth-child(2)') || {}).textContent || 0));
        if (bookingId) {
            widgetData.bookingId = bookingId;
        }
        const infoBlock = (document.querySelectorAll('.confirmation-property-info') || {})[0];
        if (infoBlock) {
            // Dates
            const dateBegin = thn.dateToString(((infoBlock.querySelector('.confirmation-item:nth-child(2) span.guest-row-data') || {}).textContent || ''));
            const dateEnd = thn.dateToString(((infoBlock.querySelector('.confirmation-item:nth-child(3) span.guest-row-data') || {}).textContent || ''));
            const price = thn.parseNumber(((infoBlock.querySelector('.confirmation-item:nth-child(7) span.guest-row-data') || {}).textContent || 0));
            let currency = ((infoBlock.querySelector('.confirmation-item:nth-child(7) span.guest-row-data') || {}).textContent || 0).match(/^[^d.]/);
            if (currency) {
                if (currency[0] === 'R') {
                    currency = 'ZAR';
                }
                else if (currency[0] === 'N') {
                    currency = 'NAD';
                }
                else {
                    currency = thn.parseCurrency(currency[0]);
                }
            }
            else {
                currency = 'ZAR';
            }
            if (dateBegin && dateEnd) {
                widgetData.dateBegin = dateBegin;
                widgetData.dateEnd = dateEnd;
            }
            if (price && currency) {
                widgetData.price = price;
                widgetData.currency = currency;
            }
        }
        return widgetData;
    };
    return engine;
}

export { factory };
